// @flow
import React, { Component } from 'react';
import {
  MerchantSalesMaterialsDiv,
  SalesFiltersDiv,
  SalesMaterialDiv
} from './SalesMaterialStyles';
import TableFilter from '../../../components/TableFilter';
import { MarketingBody } from '../MarketingBody';
import { type MarketingFile } from '../';

type Props = {
  salesMaterialFilter: string,
  setSalesMaterialFilter: (salesMaterialCategory: ?string) => void,
  downloadFile: (url: string, fileName: string) => void,
  marketingFiles: MarketingFile[],
  salesMaterialFilterOptions: Array<Object>
};

export default class SalesMaterialList extends Component<Props> {
  componentWillUnmount() {
    this.props.setSalesMaterialFilter(null);
  }

  marketingFilter(materialCategory: string, salesMaterialFilter: string) {
    if (salesMaterialFilter.endsWith('sales_videos')) {
      return materialCategory.endsWith('sales_videos');
    } else if (salesMaterialFilter.endsWith('demo_videos')) {
      return materialCategory.endsWith('demo_videos');
    } else {
      return materialCategory === salesMaterialFilter;
    }
  }
  render() {
    return (
      <MerchantSalesMaterialsDiv>
        <SalesFiltersDiv>
          <TableFilter
            value={this.props.salesMaterialFilter}
            onChange={this.props.setSalesMaterialFilter}
            // eslint-disable-next-line react/prop-types
            options={this.props.salesMaterialFilterOptions}
            label="All Material"
            rightEnd={true}
            setWidth="180px"
            outline
          />
        </SalesFiltersDiv>
        <SalesMaterialDiv>
          {!this.props.salesMaterialFilter ? (
            <MarketingBody
              marketingFiles={this.props.marketingFiles}
              downloadFile={this.props.downloadFile}
            />
          ) : (
            <MarketingBody
              downloadFile={this.props.downloadFile}
              marketingFiles={this.props.marketingFiles.filter(material =>
                this.marketingFilter(
                  material.category,
                  this.props.salesMaterialFilter
                )
              )}
            />
          )}
        </SalesMaterialDiv>
      </MerchantSalesMaterialsDiv>
    );
  }
}
